import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Question } from '../../../models/QuestionResponse';

import { TranslateModule } from '@ngx-translate/core';

enum ViewMode {
  start,
  questionning,
  end,
}

@Component({
  selector: 'q-cogres',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './cogres.component.html',
  styleUrl: './cogres.component.scss',
})
export class CogresComponent {
  @Input() question!: Question;
  @Input() pickedAnswers!: string[];
  @Input() validate!: () => void;
  @Output() pickedAnswersChange = new EventEmitter<string[]>();

  ViewMode = ViewMode;
  viewMode: ViewMode = ViewMode.start;
  aIndex: number = 0;
  countdownValue: number = 8;
  intervalId: any;
  formattedTime: string = '08';
  answerButtonState: 'normal' | 'correct' | 'incorrect' = 'normal';

  constructor() {}

  setupQuestion() {
    this.viewMode = ViewMode.start;
    this.aIndex = 0;
  }

  startQuestion() {
    this.setupCountdown();
    this.viewMode = ViewMode.questionning;
  }

  setupCountdown() {
    this.countdownValue = 8;
    this.formattedTime = '08';
    this.intervalId = setInterval(() => {
      this.formattedTime = this.countdownValue.toString().padStart(2, '0');

      if (this.countdownValue === 0) {
        clearInterval(this.intervalId);
        this.validateQuestionAndGoNextOrEnd();
      } else {
        this.countdownValue--;
      }
    }, 1000);
  }

  validateQuestionAndGoNextOrEnd() {
    if (this.pickedAnswers[this.aIndex] === '') {
      this.pickedAnswers[this.aIndex] = '0';
    }

    if (this.aIndex === this.pickedAnswers.length - 1) {
      this.endQuestion();
    } else {
      this.aIndex++;
      this.setupCountdown();
    }
  }

  endQuestion() {
    this.viewMode = ViewMode.end;
    this.validate();
  }

  toggleAnswer() {
    if (this.pickedAnswers[this.aIndex] === '' || this.pickedAnswers[this.aIndex] === '0') {
      this.pickedAnswers[this.aIndex] = '1';

      // Determine if answer is correct and set visual feedback
      const isCorrect = this.pickedAnswers[this.aIndex] === this.question.good_answers[this.aIndex];
      this.answerButtonState = isCorrect ? 'correct' : 'incorrect';

      this.pickedAnswersChange.emit(this.pickedAnswers);
      clearInterval(this.intervalId);

      // Wait for animation to complete before moving to next question
      setTimeout(() => {
        this.answerButtonState = 'normal';
        this.validateQuestionAndGoNextOrEnd();
      }, 1000);
    } else {
      this.pickedAnswers[this.aIndex] = '0';
      this.pickedAnswersChange.emit(this.pickedAnswers);
    }
  }
}
